export default {
  noMatchesFound: 'No results found. Try different search terms or adjust your filters.',
};
